import produce from "immer";

import { ITestViewState } from "../Contracts";
import { TestActionsType, TestActionTypes } from "./TestActions";
import { UHFEnvironments } from "../../../common/Constants";

export function testReducer(state: ITestViewState, action: TestActionsType): ITestViewState {
    return produce(state || ({} as ITestViewState), draft => {
        switch (action.type) {
            case TestActionTypes.InitTestView: {
                draft.messages = {};
                draft.resources = {};
                draft.testConfig = {
                    locale: "en-us",
                    partnerId: "UHFPortal",
                    headerId: "UHFPortalHeader",
                    footerId: "UHFPortalFooter",
                    environment: UHFEnvironments.PROD,
                    options: {
                        debug: false,
                        cookieCompliance: false,
                        vNext: false
                    },
                    links: {}
                };
                break;
            }
            
            case TestActionTypes.SetTestConfig: {
                draft.testConfig = { ...state.testConfig, ...action.payload };
                break;
            }


            default:
                return state;
        }
    });
}
